var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoVoltar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.513,
    height: 20,
    viewBox: "0 0 20.513 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.171,16.021c-1.1-3.545-4.6-5.964-8.79-6.036V5.841a.368.368,0,0,0-.359-.359.386.386,0,0,0-.216.072L.147,13.266a.35.35,0,0,0-.072.5l.072.072,10.659,7.665a.372.372,0,0,0,.5-.072.386.386,0,0,0,.072-.216V17.1c2.587,0,4.766,1.222,5.533,3.066.647,1.581.12,3.281-1.413,4.695a.348.348,0,0,0-.024.5.385.385,0,0,0,.263.12h.287a.272.272,0,0,0,.192-.072C19.74,23.087,21.248,19.47,20.171,16.021Z",
    transform: "translate(0 -5.482)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVoltar);
export default __webpack_public_path__ + "static/media/ico-voltar.72c090da1dbafdd81ae9ac85b8fab452.svg";
export { ForwardRef as ReactComponent };